import {getElement, getElements} from "./utils/getElement";

const initUpgradeLicense = () => {
    const licenseSelector = getElement('.js-upgrade-license-field')
    const licenseSelectorOptions = getElements('.js-upgrade-license-option')
    const licenseSelectorLabel = getElement('.c-upgrade__licenses__selected')
    const licenseSubmit = getElement('.js-upgrade-license-submit')
    if (!licenseSelector) {
        return;
    }

    licenseSelector.addEventListener('click', () => {
        licenseSelector.classList.toggle('is-open')
    })

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.js-upgrade-license-field')) {
            licenseSelector.classList.remove('is-open')
        }
    })

    licenseSelectorOptions.map( option => {
        option.addEventListener('click', (e) => {
            const upgradeUrl = option.getAttribute('data-license-upgrade_url')
            const licenseTitle = option.innerText

            licenseSubmit.disabled = false
            licenseSubmit.classList.remove('o-tooltip--upgrade')
            licenseSubmit.setAttribute('data-url', upgradeUrl)

            licenseSelector.classList.add('is-selected')
            licenseSelectorLabel.innerText = licenseTitle
        })
    })

    licenseSubmit.addEventListener('click', () => {
        window.location.href = licenseSubmit.getAttribute('data-url');
    })
}

export {initUpgradeLicense};
